import {getCookie} from '@/assets/utils'
import {Base64} from 'js-base64'

var devURL = 'https://zjy.glodon.com'
var hrefReg = /^http[s]?:\/\/([^/:]+)/
var origin = hrefReg.exec(window.location.href)
console.log(origin)
let ENV = 'product'
if (origin && origin.length > 1) {
  const uriMap = [
    // 项管ae环境---薛寒
    {origin: 'geip-pre', url: 'https://zjy-dev.glodon.com', env: 'dev'},
    {origin: 'aecloud-test', url: 'https://zjy-pre.glodon.com', env: 'pre'},
    {origin: 'xmgl-gor', url: 'https://zjy-pre.glodon.com', env: 'pre'},
    // {origin: 'geip-fat', url: 'https://zjy-dev.glodon.com', env: 'dev'},
    {origin: 'xmgl', url: 'https://zjy.glodon.com', env: 'product'},
    // 阿里开发 [启动本地服务访问此服务时，backend有白名单校验 请将本地服务端口号修改为8090]
    {origin: 'zjy-dev', url: 'https://zjy-dev.glodon.com', env: 'dev'},
    // 阿里测试 [启动本地服务访问此服务时，backend有白名单校验 请将本地服务端口号修改为8082]
    {origin: 'zjytest', url: 'https://zjytest.glodon.com', env: 'test'},
    {origin: 'zjy-pre', url: 'https://zjy-pre.glodon.com', env: 'pre'}, // 预上线
    {origin: 'zjy-component', url: 'https://zjy-component.glodon.com', env: 'pre'}, // 预上线
    {origin: 'zjy', url: 'https://zjy.glodon.com', env: 'product'}, // 线上
    {
      // url: 'https://zjytest.glodon.com', // 阿里测试
      url: 'https://zjytest.glodon.com', // pre
      // url: 'https://zjy-dev.glodon.com', // 阿里开发
      // url: 'http://10.2.33.33:8083', // 丁兆鹏开发
      // url: 'http://10.2.33.25:8284', // 韩叙 本地 bigdata 数据拆分
      env: 'dev',
      origin: 'localhost' // 前端开发人员 本地
      // origin: 'local.glodon.com' // 前端开发人员 本地
    }
  ]
  for (let i = 0; i < uriMap.length; i++) {
    const reg = new RegExp('^' + uriMap[i].origin)
    if (reg.test(origin[1])) {
      devURL = uriMap[i].url
      ENV = uriMap[i].env
      break
    }
  }
}
devURL += '/backend'
console.log(process.env.VUE_APP_BASE_URL, process.env.VUE_APP_PRIVATE, devURL)
// 当为ae环境时特殊处理，因为ae环境对应了zjytest和zjy-pre两个环境
// const regAe = new RegExp('^' + 'aecloud-test')
// if (regAe.test(origin[1])) {
//   if (window.self !== window.top){
//     const currentTopUrl = getCookie('currentTopUrl')
//     console.log(currentTopUrl)
//     if (currentTopUrl && currentTopUrl.includes('zjytest')){
//       devURL = currentTopUrl + '/backend'
//     }
//   }
// }
export const backendUrl = process.env.VUE_APP_BASE_URL || devURL // backend api 接口地址 前缀
console.log(backendUrl)
export const env = ENV
export const bimfaceUrl = 'https://api.bimface.com'
export const appkey = 'fd0f3134-dae4-42a7-8bb5-f161f621db95'
// export const  zjycloud = "http://localhost:8080"
export const zjycloud = window.location.href.includes('zjytest') ? 'http://zjytest.glodon.com:7988/cloudplat'
  : window.location.href.includes('39.96.15.61') ? 'http://39.96.15.61:8020'
    : window.location.href.includes('localhost') ? 'http://localhost:8080'
      : window.location.href.includes('cloudplat-tjs') ? 'https://zjytest.glodon.com/cloudplat-tjs'
        : window.location.href.includes('cloudplat-tjb') ? 'https://zjytest.glodon.com/cloudplat-tjb'
          : window.location.href.includes('zjytest') ? 'https://zjytest.glodon.com'
            : window.location.href.includes('zjyrefactor') ? 'http://zjyrefactor.glodon.com'
              : window.location.href.includes('zjy-pre') ? 'https://zjy-pre.glodon.com'
                : window.location.href.includes('zjy-gray-pre') ? 'https://zjy-gray-pre.glodon.com'
                  : window.location.href.includes('zjy-gray') ? 'https://zjy-gray.glodon.com'
                    : 'https://zjy.glodon.com'

export const aecore = window.location.href.includes('zjytest') ? 'https://aecore-test.glodon.com/ops'
  : window.location.href.includes('localhost') ? 'https://aecore-test.glodon.com/ops'
  // window.location.href.includes('localhost') ? 'http://192.168.130.40/portal' :
    : 'https://aecore.glodon.com/ops'

// 意见反馈请求头认证信息
export const authorization = Base64.encode(`${getCookie('gldUserId')}_-101001_${getCookie('gldToken')}`)

// 项管环境地址
export const geipUrl = window.location.href.includes('localhost') ? 'https://geip-pre.glodon.com'
  : window.location.href.includes('aecloud-test') ? 'https://aecloud-test.glodon.com'
    : window.location.href.includes('xmgl-gor') ? 'https://xmgl-gor.glodon.com'
      : window.location.href.includes('zjy-pre') ? 'https://aecloud-test.glodon.com'
        : window.location.href.includes('zjytest') ? 'https://aecloud-test.glodon.com'
          : window.location.href.includes('zjy-dev') ? 'https://geip-pre.glodon.com'
            : window.location.href.includes('zjy-component') ? 'https://aecloud-test.glodon.com'
              : window.location.href.includes('zjy') ? 'https://xmgl.glodon.com'
                : 'https://xmgl.glodon.com'

// 预览服务地址
export const previewHrefUrl = window.location.href.includes('localhost') ? 'https://zjytest.glodon.com'
  : window.location.href.includes('zjy-dev') ? 'https://zjy-dev.glodon.com'
    : window.location.href.includes('zjytest') ? 'https://zjytest.glodon.com'
      : window.location.href.includes('zjy-pre') ? 'https://zjy-pre.glodon.com'
        : window.location.href.includes('zjy-component') ? 'https://zjy-component.glodon.com'
          : window.location.href.includes('geip-pre') ? 'https://zjy-dev.glodon.com'
            : window.location.href.includes('aecloud-test') ? 'https://zjy-pre.glodon.com'
              : window.location.href.includes('xmgl-gor') ? 'https://zjy-pre.glodon.com'
                : window.location.href.includes('xmgl') ? 'https://zjy.glodon.com'
                  : 'https://zjy.glodon.com'

// 广材环境地址
export const qydataUrl = window.location.href.includes('localhost') ? 'https://qydata.glodon.com'
  : window.location.href.includes('zjy-dev') ? 'https://qydata.glodon.com'
    : window.location.href.includes('zjytest-gray') ? 'https://qydata-test.glodon.com'
      : window.location.href.includes('zjytest') ? 'https://qydata-test.glodon.com'
        : window.location.href.includes('zjy-gray-pre') ? 'https://qydata.glodon.com'
          : window.location.href.includes('zjy-pre') ? 'https://qydata.glodon.com'
            : window.location.href.includes('aecloud-test') ? 'https://qydata.glodon.com'
              : 'https://qydata.glodon.com'
// 埋点产品码
export const pcode = window.location.host === 'zjy.glodon.com' ? '-101001' : '84420'

// 用户中心环境地址
export const accountUrl = window.location.href.includes('zjytest') ? 'https://account.glodon.com'
  : window.location.href.includes('zjy-dev') ? 'https://account-test.glodon.com'
    : window.location.href.includes('zjy-pre') ? 'https://aecloud-test.glodon.com'
      : window.location.href.includes('zjy-component') ? 'https://xmgl-gor.glodon.com'
        : window.location.href.includes('zjy') ? 'https://xmgl.glodon.com'
          : window.location.href.includes('localhost') ? 'https://xmgl-gor.glodon.com'
            : 'https://account.glodon.com'

// 一冶项目地址
export const cfmccUrl = window.location.href.includes('localhost') ? 'http://localhost:7778/cfmcc/'
  : window.location.href.includes('zjy-dev') ? 'https://zjy-dev.glodon.com/cfmcc/'
    : window.location.href.includes('zjytest-gray') ? 'https://zjytest-gray.glodon.com/cfmcc/'
      : window.location.href.includes('zjytest') ? 'https://zjytest.glodon.com/cfmcc/'
        : window.location.href.includes('zjy-gray-pre') ? 'https://zjy-gray-pre.glodon.com//cfmcc/'
          : window.location.href.includes('zjy-pre') ? 'https://zjy-pre.glodon.com/cfmcc/'
            : window.location.href.includes('zjy-gray') ? 'https://zjy-gray.glodon.com/cfmcc/'
              : 'https://zjy.glodon.com/cfmcc/'


// dcost跳转地址
export const dcostUrl = window.location.href.includes('localhost') ? 'https://dcost-pre.glodon.com/'
  : window.location.href.includes('geip-pre.glodon.com') ? 'https://dcost-te.glodon.com/'
    : window.location.href.includes('aecloud-test.glodon.com') ? 'https://dcost-pre.glodon.com/'
     : window.location.href.includes('xmgl.glodon.com') ? 'https://dcost.glodon.com/'
       : window.location.href.includes('zjytest.glodon.com') ? 'https://dcost-pre.glodon.com/'
        : 'https://dcost.glodon.com/'
